// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e9-V","col":"styles_col__26dFW"};